/* eslint-disable no-console */
import { register } from 'register-service-worker'
import alertify from 'alertify.js'

const notifyUserAboutUpdate = Worker => {
  alertify.confirm('new content!', () => {
    Worker.postMessage({ action: 'skipWaiting' })
  })
}
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (reg) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB', reg
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      notifyUserAboutUpdate(registration.waiting)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    },
    addEventListener (fetch, event) {
      console.error('ENTREI NO FECTCH EVENT:', event)
    }
  })
  var refresing
  navigator.serviceWorker.addEventListener('controllerchange', function () {
    console.error('ENTREI NO NAVIGATOR')
    if (refresing) return
    window.location.reload()
    refresing = true
  })
}
